import firebase from 'firebase/app';
import 'firebase/firestore';

export const db = firebase
  .initializeApp({
    projectId: 'prosenote',
    apiKey: 'AIzaSyBPW683v2VFBJpbMvkMAFoAwYMbh-qqQVE',
    // authDomain: 'localhost',
  })
  .firestore();

const { Timestamp } = firebase.firestore;
export { Timestamp };
